export const ADD_EVENT = 'ADD_EVENT';
export const CLEAR_EVENTS = 'CLEAR_EVENTS';
export const ADD_PUBLIC_EVENTS = 'ADD_PUBLIC_EVENTS';
export const ADD_ALL_EVENTS = 'ADD_ALL_EVENTS';
